export default "__VITE_ASSET__BadfPAib__"